import React, { useContext } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { LoggedInContext } from "./authContextProvider";

type Props = {
  component: React.ReactNode;
};

export const RouteAuthGuard: React.FC<Props> = (props) => {
  const [loggedIn] = useContext(LoggedInContext);
  const { pathname } = useLocation();
  // ログインしているのにloginページへアクセスしたらtopへリダイレクトする
  if (loggedIn === true && pathname === "/login") {
    return <Navigate to={"/"} replace={false} />;
  }
  // ログインしていない場合でも、refreshTokenがあれば復旧の可能性があるため
  // 直ちにリダイレクトせず、Sessionに復旧を委ねる
  if (loggedIn === false && pathname !== "/login") {
    const hasRefresh = Boolean(localStorage.getItem("refreshToken"));
    if (!hasRefresh) {
      return <Navigate to={"/login"} replace={false} />;
    }
  }

  return <>{props.component}</>;
};
